import React from 'react';
import { useLanguage } from '../../LanguageProvider';
import Dropdown from '../Dropdown/Dropdown';

export default function LanguageSelect() {
    const { language, changeLanguage } = useLanguage();

    const handleLanguageChange = (event) => {
        changeLanguage(event.target.value);
    };

    const languageOptions = [
        { value: 'en', label: 'EN' },
        { value: 'tr', label: 'TR' },
        { value: 'de', label: 'DE' },
        { value: 'it', label: 'IT' },
        { value: 'es', label: 'ES' },
        { value: 'fr', label: 'FR' },
        // Daha fazla dil buraya eklenebilir
    ];

    return (
        <div>
            <Dropdown
            style={{maxWidth:'95px'}}
                value={language}
                options={languageOptions}
                onChange={handleLanguageChange}
            />
        </div>
    );
}
